var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "container-fluid password-container",
      class: { hide_banner: !_vm.isTokenValid },
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 txt-alg-ctr",
          },
          [
            _vm.isTokenValid
              ? _c(
                  "div",
                  { staticClass: "login-whitebox landinglayout_box_wrapper" },
                  [
                    _c("h1", [_vm._v("Create an account")]),
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.confirmAccount.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("p", { staticClass: "mb-20" }, [
                          _vm._v(
                            "Please enter a password below to create your account."
                          ),
                        ]),
                        _c("div", { staticClass: "login-container" }, [
                          _c("div", { staticClass: "login-input" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.$v.data.password.$model,
                                  expression: "$v.data.password.$model",
                                  modifiers: { trim: true },
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.data.password,
                                  expression: "data.password",
                                },
                              ],
                              ref: "inputNewTag",
                              staticClass:
                                "login-input-box landing-input-field",
                              class: {
                                field_error: _vm.$v.data.password.$error,
                              },
                              attrs: {
                                type: "password",
                                name: "password",
                                placeholder: "New password",
                              },
                              domProps: {
                                value: _vm.$v.data.password.$model,
                                value: _vm.data.password,
                              },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.data,
                                      "password",
                                      $event.target.value
                                    )
                                  },
                                  function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.$v.data.password,
                                      "$model",
                                      $event.target.value.trim()
                                    )
                                  },
                                ],
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                            _c("i", { staticClass: "fa fa-lock" }),
                            _vm.showNewPassword
                              ? _c("img", {
                                  staticClass: "eye-icon",
                                  attrs: {
                                    src: "/static/images/icons/eye.svg",
                                    alt: "eye-icon",
                                  },
                                  on: { click: _vm.toggleNewPassword },
                                })
                              : _vm._e(),
                            !_vm.showNewPassword
                              ? _c("img", {
                                  staticClass: "eye-slash-icon",
                                  attrs: {
                                    src: "/static/images/icons/eye_slash.svg",
                                    alt: "eye-icon",
                                  },
                                  on: { click: _vm.toggleNewPassword },
                                })
                              : _vm._e(),
                          ]),
                          _vm.$v.data.password.$error
                            ? _c("div", { staticClass: "error_text" }, [
                                !_vm.$v.data.password.required
                                  ? _c("div", [_vm._v("Password is required.")])
                                  : _vm._e(),
                                _vm.$v.data.password.required &&
                                !_vm.$v.data.password.passwordValidation
                                  ? _c("div", [
                                      _vm._v(
                                        " Password must include at least 10 characters "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        "Your password must meet 3 of these 4 criteria: 1 capital letter (A-Z), 1 lowercase letter (a-z), 1 number (1-9), and one special character (!@#$.,+=( )_%^&*) "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "login-container" }, [
                          _c("div", { staticClass: "login-input" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.$v.data.confirm_password.$model,
                                  expression: "$v.data.confirm_password.$model",
                                  modifiers: { trim: true },
                                },
                              ],
                              ref: "inputConfirmTag",
                              staticClass:
                                "login-input-box landing-input-field",
                              class: {
                                field_error:
                                  _vm.$v.data.confirm_password.$error,
                              },
                              attrs: {
                                type: "password",
                                name: "confirm_password",
                                placeholder: "Confirm password",
                              },
                              domProps: {
                                value: _vm.$v.data.confirm_password.$model,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.$v.data.confirm_password,
                                    "$model",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                            _c("i", { staticClass: "fa fa-lock" }),
                            _vm.showConfirmPassword
                              ? _c("img", {
                                  staticClass: "eye-icon",
                                  attrs: {
                                    src: "/static/images/icons/eye.svg",
                                    alt: "eye-icon",
                                  },
                                  on: { click: _vm.toggleConfirmPassword },
                                })
                              : _vm._e(),
                            !_vm.showConfirmPassword
                              ? _c("img", {
                                  staticClass: "eye-slash-icon",
                                  attrs: {
                                    src: "/static/images/icons/eye_slash.svg",
                                    alt: "eye-icon",
                                  },
                                  on: { click: _vm.toggleConfirmPassword },
                                })
                              : _vm._e(),
                          ]),
                          _vm.$v.data.confirm_password.$error
                            ? _c("div", { staticClass: "error_text" }, [
                                !_vm.$v.data.confirm_password.required
                                  ? _c("div", [
                                      _vm._v("Please confirm your password"),
                                    ])
                                  : _vm._e(),
                                _vm.$v.data.confirm_password.required &&
                                !_vm.$v.data.confirm_password.sameAsPassword
                                  ? _c("div", [
                                      _vm._v(
                                        " The password doesn't match the password above "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]),
                        _c("div", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.$v.data.terms_conditions.$model,
                                expression: "$v.data.terms_conditions.$model",
                                modifiers: { trim: true },
                              },
                            ],
                            attrs: { type: "checkbox", value: "true" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.$v.data.terms_conditions.$model
                              )
                                ? _vm._i(
                                    _vm.$v.data.terms_conditions.$model,
                                    "true"
                                  ) > -1
                                : _vm.$v.data.terms_conditions.$model,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.$v.data.terms_conditions.$model,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "true",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.$v.data.terms_conditions,
                                        "$model",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.$v.data.terms_conditions,
                                        "$model",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.$v.data.terms_conditions,
                                    "$model",
                                    $$c
                                  )
                                }
                              },
                            },
                          }),
                          _vm._m(0),
                          _vm.$v.data.terms_conditions.$error
                            ? _c("div", { staticClass: "error_text" }, [
                                !_vm.$v.data.terms_conditions.checked
                                  ? _c("div", [
                                      _vm._v(
                                        " You must accept the Privacy and Cookie Policies to create an account "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]),
                        _vm.errorMessage
                          ? _c("div", { staticClass: "error-msg-holder" }, [
                              _c("span", { staticClass: "error-message" }, [
                                _vm._v(_vm._s(_vm.errorMessage)),
                              ]),
                              _c("br"),
                            ])
                          : _vm._e(),
                        _c(
                          "button",
                          {
                            staticClass: "btn emergo-green-button mt-20",
                            attrs: {
                              type: "submit",
                              disabled: _vm.disableButton,
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.ButtonText) + " ")]
                        ),
                      ]
                    ),
                  ]
                )
              : _c(
                  "div",
                  [
                    _c("invalid-token-message", {
                      attrs: { page: "confirmregister" },
                    }),
                  ],
                  1
                ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "terms-conditions" }, [
      _vm._v(" I acknowledge that I have read and agree to the "),
      _c("span", { staticClass: "term-priv" }, [
        _c("a", { attrs: { href: "/termsandconditions", target: "_blank" } }, [
          _vm._v("RAMS Software-as-a-Service Agreement"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }